import { addInvitation, ADD_INVITATION } from './addInvitation';
import {
    requestAnInvitation,
    REQUEST_AN_INVITATION,
} from './requestAnInvitation';

export const invitationMutations = { addInvitation, requestAnInvitation };

export const invitationQueryStrings = { ADD_INVITATION, REQUEST_AN_INVITATION };
